import React, { useState, useEffect } from "react";

import { SAdefaultValues, selectDateOrTime, selectTypes } from "../../../../../services/saleAnalysis-services";
import {
  Button,
  Chip,
  colors,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import ProfitMarginForm from "./ProfitMargin-form";
import ProfitMarginTable from "./ProfitMargin-table";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import LoadingPage from "../../../../../services/LoadingPage";
import i18next from "i18next";
import { sto } from "../../../../../Context/InshData";
import moment from "moment";
import DailyReportFilter from "../EveryDay/DailyReportFilter";
import { branch } from "recompose";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor: "#fff",
    padding: 5,
    textAlign: "center",
    fontSize: 24,
    width: "100%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
}));

export default function ProfitMargin(props) {
  const { AutoOptions, CustomerOptions, isPurches,branch, setBranch } = props;
  let idSafe = AutoOptions.Safes[0].id;
  let nameSafe = AutoOptions.Safes[0].name;

  let iduser = AutoOptions.Users[0].id;
  let nameuser = AutoOptions.Users[0].name;

  let idstock = AutoOptions.Stocks[0].id;
  let namestock = AutoOptions.Stocks[0].name;


  let idBranch = AutoOptions.Branches[0].id;
  let nameBranch = AutoOptions.Branches[0].name;
  const SAdefaultValues = {
    selectType: selectTypes[0],
    dateFrom: moment(new Date()).format('YYYY-MM-DD'),
    timeFrom: moment(new Date()).format('HH:mm'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    timeTo: moment(new Date()).format('HH:mm'),
    selectTime: selectDateOrTime[0],
    safe: { id: sto.User_typei == 1 ? -1 : idSafe, name: sto.User_typei == 1 ? "الكل" : nameSafe },
    cust: { id: -1, name: "الكل" },
    user: { id: sto.User_typei == 1 ? -1 : iduser, name: sto.User_typei == 1 ? "الكل" : nameuser },
    stock: { id: sto.User_typei == 1 ? -1 : idstock, name: sto.User_typei == 1 ? "الكل" : namestock },
    sales_man: { id: -1, name: "الكل" },
    group: { id: -1, name: "الكل" },
    branch: { id: sto.User_typei == 1 ? -1 : idBranch, name: sto.User_typei == 1 ? "الكل" : nameBranch },
    chk_withvat: false,
    type_cost: 1,
  };
  const [rptParams, setRptParams] = React.useState(SAdefaultValues);
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();
  const { t } = useTranslation(["forms", "translation"]);
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  
  const viewHandle = async () => {

    setData([]);
    setFetching(true);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSales/SalesAnalysis?type_Select=${"Currencies"}
    &&branch=${sto.User_typei == 1?branch?.id: rptParams.branch?.id}
    &&dateFrom=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
    &&dateTo=${rptParams.dateTo + ' ' + rptParams.timeTo}
    &&stock=${rptParams.stock.id}
    &&cust=${rptParams.cust.id}
    &&safe=${rptParams.safe.id}
    &&sales_man=${-1}
    &&groups=${rptParams.group.id}
    &&user=${rptParams.user.id}
    &&chk_withvat=${rptParams.chk_withvat}
    &&type_cost=${0}
    &&isPurch=${false}
    &&date_timeA=${rptParams.selectTime.name}`
    } else {
      Urls =`RptSales/SalesAnalysis?type_Select=${"Currencies"}
    &&branch=${sto.User_typei == 1?branch?.id: rptParams.branch?.id}
    &&dateFrom=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
    &&dateTo=${rptParams.dateTo + ' ' + rptParams.timeTo}
    &&stock=${rptParams.stock.id}
    &&cust=${rptParams.cust.id}
    &&safe=${rptParams.safe.id}
    &&sales_man=${-1}
    &&groups=${rptParams.group.id}
    &&user=${rptParams.user.id}
    &&chk_withvat=${rptParams.chk_withvat}
    &&type_cost=${0}
    &&isPurch=${false}
    &&date_timeA=${rptParams.selectTime.name}
    &&db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err("يوجد خطأ في الجلب");
        setData([]);
      });
  };


  const his = useHistory();

  const printHandle = () => {
    if (data.lenght == 0) {
      alert("لاتوجد بيانات");
    } else {
      const info = {
        data: data?.saleAnalysis,
        tot: data?.totals,
        title: "تقرير هامش الربح",
        auto: {},
        fDate: rptParams.dateFrom,
        tDate: rptParams.dateTo,
        ElmntShow: true,
        safe: rptParams.safe.name,
        stock: rptParams.stock.name,
        branch: sto.User_typei == 1 ? branch?.name : rptParams?.branch?.name,
        cust: rptParams.cust.name,
        sales_man: rptParams.sales_man.name,
        username: rptParams.user.name,
        group: rptParams.group.name,
        labelname: t(rptParams.selectType.label),
        //totsp:rpt.totSelcPeriod,balncsp:rpt.balncSelcPeriod
      };
      localStorage.setItem("iInfos", JSON.stringify(info));
      his.push({ pathname: "/AnalysisPrint" });
      window.location.reload(true);
    }
  };


  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
    if (propName === "branch" && sto.User_typei == 1) {
      setBranch(newValue);
      setRptParams({ ...rptParams, [propName]: newValue });
    }
  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          {t("translation:profit-margin")}
        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor: colors.green[300],
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <DailyReportFilter {...{ rptParams, setRptParams, isPurches }} />

          <ProfitMarginForm
            {...{
              AutoOptions,
              CustomerOptions,
              rptParams,
              onChangeData,
              onChangeAutoData,
              printHandle,
              isPurches,
              branch
            }}
          />
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={
                  (isPurches ? inshst.purch.iconBtn : inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                className={[clasui.buttonSal]}
                onClick={() => viewHandle()}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={[clasui.buttonSal]}
                style={
                  (isPurches ? inshst.purch.iconBtn : inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  (isPurches ? inshst.purch.iconBtn : inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
            {/* <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={{ ...inshst.sal.iconBtnRpt, borderRadius: 0 }}
                onClick={() => {
                  his.push({ pathname: "/" });
                }}
              >
                {t("forms:exit")}
              </Button>
            </Grid> */}
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  title: t("forms:net-quantity"),
                  value: data?.totals?.qtyTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  title: t("forms:net-total"),
                  value: data?.totals?.totNetTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  title: t("forms:net-discount"),
                  value: data?.totals?.minusTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  title: t("forms:net-cost"),
                  value: data?.totals?.costTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  title: "صافي الضريبة",
                  value: data?.totals?.vatTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  title: t("forms:net-profit"),
                  value: data?.totals?.profitTotal.toFixed(2),
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color={colors.indigo[300]} />
              {!fetching && (
                <ProfitMarginTable
                  {...{
                    data: data?.saleAnalysis ? data.saleAnalysis : [],
                    title: rptParams.selectType.label,
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
